var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.stackedBars = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    var debugWidget = widget.data('id') === '9c3eee42-35b7-4f8f-b33b-d369011ae9e3';


    setTimeout(function () {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);

        var isBarsAndLinesWidget = widget.data('type') === 31;

        var useLegacyKeyTransform = metadata && metadata.KendoConfig && metadata.KendoConfig._UseLegacyKeyTransformation;

        var container = $('<div class="stacked-bars">').css({ width: '90%', height: '90%', top: '5%', left: '5%' });

        var keyMappings = MDB.Charts.transformKeysToKendoFields(data, useLegacyKeyTransform);
        var keyMappingFields = _.map(keyMappings, 'field');

        var keys = MDB.Charts.getDataKeys(data[0]);
        var sharedValueAxisMax = metadata && metadata.KendoConfig && metadata.KendoConfig._SharedValueAxisMax;

        var category = keyMappings[0].field;
        var series = [];
        var aliasses = MDB.Charts.getColumnAliasses(widget);
        
        var continuousPalette = metadata && metadata.KendoConfig && metadata.KendoConfig._ContinuousPalette;
        var colorGenerator = getColorGenerator();

        var nonStackedSeries = [];
        var nonStackedDataKeys = [];

        if (metadata && metadata.KendoConfig && metadata.KendoConfig.seriesDefaults && metadata.KendoConfig.seriesDefaults.stack) {
            var stackConfig = metadata.KendoConfig.seriesDefaults.stack;
            var hasGroups = stackConfig._stackGroupingVisible;
            var valueIndex = stackConfig._indexValueColumn || (hasGroups ? 3 : 2);
            var stackColumnIndex = stackConfig._indexStackColumn || 1;
            var stackField = keyMappingFields[stackColumnIndex];
            var stacks = _.uniq(_.map(data, stackField));
            var stackGroupIndex, stackGroup, groups;
            var stackCategories = _.filter(_.uniq(_.map(data, category)), function(c) {
                return c !== undefined && c !== null; 
            });
            var totalStack = stackConfig._displayTotal;
            var total = 'Total';

            var stackFieldKeyMappings = [
                keyMappings[0],
                keyMappings[stackColumnIndex],
                keyMappings[valueIndex],
                hasGroups ? keyMappings[stackConfig._indexStackGroupColumn || 2] : undefined
            ];

            stackFieldKeyMappings = _.map(_.filter(stackFieldKeyMappings), 'field');

            var nonStackedData = _.map(data, function(d){
                return _.pickBy(d, function(i, k){
                    return stackFieldKeyMappings.indexOf(k) === -1;
                });
            });

            nonStackedDataKeys = _.uniq(_.flatMap(nonStackedData, _.keys));
            nonStackedSeries = _.filter(metadata.KendoConfig.series, {type: 'line'}) || [];

            //Stack has to be explicitly set to false in order to override the seriesDefaults.stack
            nonStackedSeries.forEach(function(series){
                series.stack = false;
            });

            //Filter null categories
            data = _.filter(data, function (d) {
                return stackCategories.indexOf(d[category]) !== -1 
            });

            // var orderedStacks = _.map(_.find(_.groupBy(data, category), function (gr){ return gr.length === stacks.length; }), stackField);

            if (hasGroups) {
                stackGroupIndex = stackConfig._indexStackGroupColumn || 2;
                stackGroup = keyMappingFields[stackGroupIndex];
                groups = _.uniq(_.map(data, stackGroup));
            }

            //To determine the order of our stacks; we first need to group data by category (and group when available)
            var groupedStacks = data.reduce(function(accumulator, current){
                //Grouping key: category + stackGroup
                var key = current[category];
                if(hasGroups){
                    key += current[stackGroup];
                }

                //Either take the existing array on our accumulator
                //or add an entry with the given key
                //Push the data record's stack to said array
                (accumulator[key] || (accumulator[key] = [])).push(current[stackField]);
                return accumulator;
            }, {});

            //Used for determining offset for spliced items
            //Take the first entry containing all stacks
            var orderedStacks = _.find(groupedStacks, function(groupedStack){
                return groupedStack.length === stacks.length;
            });

            orderedStacks = orderedStacks || [];
            var hasOrderedStacks = !!orderedStacks.length;
            
            
            if (totalStack) {
                stacks.push(total);
                if (orderedStacks.indexOf(total) === -1) {
                    orderedStacks.push(total);
                }

                (hasGroups ? groups : [undefined]).forEach(function (group) {
                    stackCategories.forEach(function (stackCategory) {
                        var totalStackItem = {};
                        totalStackItem[category] = stackCategory;
                        totalStackItem[stackField] = total;
                        totalStackItem[keyMappingFields[valueIndex]] = 1;

                        if (group !== undefined) {
                            totalStackItem[stackGroup] = group;
                        }

                        data.push(totalStackItem);
                    });
                });
            }

            var categoriesPerStack = {
                _knownGroupNames: [],
                _knownStackNames: [],

                _stacks: {},

                registerItemCategory: function (dataItem) {
                    var self = categoriesPerStack;

                    var stack = dataItem[stackField];
                    var stackCategory = dataItem[category];

                    var stacks = self._stacks;

                    if (hasGroups) {
                        var group = dataItem[stackGroup];
                        if (self._knownGroupNames.indexOf(group) === -1) {
                            self._knownGroupNames.push(group);
                        }

                        if (!stacks[group]) {
                            stacks[group] = {};
                        }

                        stacks = stacks[group];
                    }

                    if (self._knownStackNames.indexOf(stack) === -1) {
                        self._knownStackNames.push(stack);
                    }

                    if (!stacks[stack]) {
                        stacks[stack] = [];
                    }

                    stacks[stack].push(stackCategory);
                },
                forEachUnknownStackCategory: function (fn) {
                    var self = categoriesPerStack;

                    _.forEach(hasGroups ? self._knownGroupNames : [undefined], function (group) {
                        var internalCategoriesPerStack = hasGroups ? self._stacks[group] : self._stacks;

                        _.intersection(_.keys(internalCategoriesPerStack, stacks)).forEach(function (stack) {
                            stackCategories.forEach(function (stackCategory) {
                                if (internalCategoriesPerStack[stack].indexOf(stackCategory) === -1) {
                                    fn({
                                        group: group,
                                        stack: stack,
                                        category: stackCategory
                                    });
                                }
                            });
                        });
                    });
                }
            };

            data.forEach(function (d) {
                if (d === data.metadata) {
                    return;
                }

                categoriesPerStack.registerItemCategory(d);
            });

            categoriesPerStack.forEachUnknownStackCategory(function (info) {
                var item = {};

                item[category] = info.category;
                item[stackField] = info.stack;
                item[keyMappingFields[valueIndex]] = undefined;

                if (hasGroups) {
                    item[[keyMappingFields[stackGroupIndex]]] = info.group;
                }

                var firstDataItem = data.find(function (d) {
                    return d[category] === info.category && hasGroups ? d[stackGroup] === info.group : true;
                });

                var targetIndex = data.indexOf(firstDataItem) + stacks.indexOf(info.stack);

                data.splice(targetIndex, 0, item);
            });

            data = _.orderBy(data, function (dataItem) {
                return stackCategories.indexOf(dataItem[category]) + (hasGroups ? groups.indexOf(dataItem[stackGroup]) : 0);
            });

            //Only overwrite stacks if we have atleast one item containing all stacks
            if(hasOrderedStacks){
                stacks = orderedStacks;
            }

            var seriesBase = undefined;
            var seriesBaseIndex = -1;

            if(metadata.KendoConfig && metadata.KendoConfig.series){
                seriesBase = _.find(metadata.KendoConfig.series, {'type': 'column'});
                seriesBaseIndex = metadata.KendoConfig.series.indexOf(seriesBase);

                if(!seriesBase && metadata.KendoConfig.seriesDefaults.type === 'column'){
                    seriesBase = metadata.KendoConfig.seriesDefaults;
                }
            }

            if(seriesBaseIndex === -1){
                seriesBaseIndex = undefined;
            }

            seriesBase = seriesBase || {};
            
            stacks.forEach(function (stack) {
                if (hasGroups) {
                    groups.forEach(function (group) {
                        series.push($.extend({
                            _category: stack,
                            _isTotalSeries: totalStack && stack === total,
                            _seriesBaseIndex: seriesBaseIndex,

                            name: stackGroup + ': ' + (aliasses[group] || group) + ', ' + stackField + ': ' + (aliasses[stack] || stack),
                            field: keyMappingFields[valueIndex],
                            categoryField: category,
                            stack: { group: (aliasses[group] || group).toString() },
                            data: data.filter(function (row) {
                                return row[stackGroup] == group && row[stackField] == stack;
                            }),
                            color: colorGenerator
                        }, seriesBase));
                    });
                } else {
                    series.push($.extend({
                        _category: stack,
                        _isTotalSeries: totalStack && stack === total,
                        _seriesBaseIndex: seriesBaseIndex,

                        name: aliasses[stack] || stack,
                        field: keyMappingFields[valueIndex],
                        categoryField: category,
                        data: data.filter(function (row) {
                            return row[stackField] == stack;
                        }),
                        color: colorGenerator
                    }, seriesBase));
                }
            });
        } else {
            nonStackedDataKeys = keys.slice(1);
            nonStackedSeries = [];
            
            if (metadata && metadata.KendoConfig) {
                //Everything is non-stacked
                if(metadata.KendoConfig.series){
                    nonStackedSeries = metadata.KendoConfig.series;
                }

                //Not made for Bars and Lines, breaks colors
                if(!isBarsAndLinesWidget && metadata.KendoConfig.seriesColors){
                    MDB.Charts.embedColorsInData(data, metadata.KendoConfig.seriesColors);
                }
            }
        }

        nonStackedDataKeys.forEach(function (key, idx) {
            var seriesBase = nonStackedSeries[idx] || {};
            var keyMapping = keyMappings.findByKey(key) || {key: key, originalKey: key};

            series.push($.extend({
                name: aliasses[key] || keyMapping.originalKey,
                field: keyMapping.field,
                categoryField: category,
                data: data
                
                //We don't want to alternate color for every point within a line
                // color: colorGenerator
            }, seriesBase));
        });

        // sample data, quick check to see if the first record has used a date for grouping: 2016-02-01T00:00:00
        var categoryAxisType = undefined;
        if (series.length > 0 && series[0].data && series[0].data.length > 0) {
            var tmp = series[0].data[0][category];
            if (tmp && tmp.length === 19 && /\d{4}(-\d{2}){2}T(\d{2}\:){2}\d{2}/.test(tmp)) {
                categoryAxisType = 'date';
            }
        }

        var kendoConfig = {
            series: series,
            categoryAxis: {
                type: categoryAxisType,
                labels: {
                    rotation: 45
                }
            },
            dataSource: {
                data: {
                    group: {
                        field: category
                    }
                }
            }
        };

        // add custom config
        var widgetConfig = widget.data('config');
        if (widgetConfig && widgetConfig.kendoOpts) {
            $.extend(true, kendoConfig, widgetConfig.kendoOpts);
        }

        if (metadata.KendoConfig){
            if(metadata.KendoConfig.series){
                //If a series was dynamically generated, look up the series it was based on by provided index
                //Otherwise, just take the 'default' index
                kendoConfig.series.forEach(function(series, idx){
                    idx = series._seriesBaseIndex !== undefined ? series._seriesBaseIndex : idx;
                    var seriesBase = metadata.KendoConfig.series[idx];

                    if(seriesBase){
                        $.extend(true, series, seriesBase);
                    }
                });

                //Delete the original array after we're done with it as it will alter our current series
                delete metadata.KendoConfig.series;
            }

            $.extend(true, kendoConfig, metadata.KendoConfig);
        }

        if (metadata.Colors && metadata.Colors.length > 0) {
            config.seriesColors = metadata.Colors;
        }

        if (!kendoConfig.seriesDefaults) {
            kendoConfig.seriesDefaults = {};
        }

        MDB.Charts.setKendoClickHandler(kendoConfig, widget, function(data){
            var jsonData = {};
            var series = data.series;

            jsonData[keyMappings.findByKey(series.field).originalKey] = data.value;
            jsonData[keyMappings.findByKey(series.categoryField).originalKey] = data.category;

            if(stackField){
                jsonData[keyMappings.findByKey(stackField).originalKey] = series.name;
            }

            if(stackGroup){
                jsonData[keyMappings.findByKey(stackGroup).originalKey] = series.stack.group;
            }

            return jsonData;
        });

        MDB.Charts.setCategoryAxisWeekDisplayToWeekNumbers(kendoConfig);

        kendoConfig.seriesDefaults.tooltip = (kendoConfig.seriesDefaults.tooltip || { visible: true, format: '{0}' });


        embedCustomValueColors(kendoConfig);

        if (totalStack) {
            //Totals should not be necessary anymore and only serve to polute the aggregated data at this point
            data = _.difference(data, _.flatten(_.map(_.filter(kendoConfig.series, { '_isTotalSeries': true }), 'data')));
        }

        var getGlobalDataString = undefined;
        var globalDataKey = widget.data('id');
        var formatableValues = getFormatableValues(undefined, globalDataKey, function (globalDataString) {
            getGlobalDataString = globalDataString;
        });

        var getCurrentFormatableValues = function(){
            return formatableValues; 
        };

        var applyExtraLabelFormatting = function (target, template) {
            if (getGlobalDataString) {
                return '# if(' + getGlobalDataString + ') { # ' + template + ' # } # ';
            }

            //Custom labels always apply for a totalstack
            if (totalStack) {
                if (target.format) {
                    //sprintf can't be used here, ironically due to the format of the formatType arg
                    return '#= kendo.format("' + target.format + '", MDB.Charts.getGlobalData("' + globalDataKey + '")(undefined, arguments[0])) #';
                }

                return sprintf('#= MDB.Charts.getGlobalData(\'%s\')(undefined, arguments[0]) #', globalDataKey);
            }

            return template;
        };

        var applyExtraTooltipFormatting = function (target, template) {
            var kendoFormatValue = 'value';
            if (totalStack) {
                
                //Webpack's minifier assumes the wrong context when a function is directly stringified
                //thus causing invalid variables to be used
                //as a workaround, we'll have to build the stringified function ourselves
                var fnString = [
                    'function(args) {',
                        'if (series._isTotalSeries === true) {',
                            'return MDB.Charts.getGlobalData("%s")(undefined, args);',
                        '}',
    
                        //Save to seriesValue to avoid using the 'value' parameter
                        //due to a replace happening later on
                        'var seriesValue = value;',
    
                        //Kendo's renderer renders 'null' values literally while it replaces undefined with an empty value
                        'if(seriesValue === null){',
                            'seriesValue = undefined;',
                        '}',
    
                        'return seriesValue;',
                    '}'
                ].join('');
                
                /*
                function(args) {
                    if (series._isTotalSeries === true) {
                        return MDB.Charts.getGlobalData("%s")(undefined, args);
                    }
                    
                    //Save to seriesValue to avoid using the parameter that cannot be named (including comments)
                    //due to a replace happening later on
                    var seriesValue = value;
                    
                    //Kendo's renderer renders 'null' values literally while it replaces undefined with an empty value
                    if(seriesValue === null){
                        seriesValue = undefined
                    }
                    
                    return seriesValue;
                }.toString()
                 */

                kendoFormatValue = '(' + sprintf(fnString, globalDataKey) + ')(arguments[0])';
            }
            
            template = template || sprintf('#= kendo.format(\'%s\', %s) #', target.format || '{0}', kendoFormatValue);
            template = template.replace('value', kendoFormatValue);
            template = MDB.Charts.combineWithDefaultTooltipTemplate(template, target);
            
            return template;
        };
        
        if(isBarsAndLinesWidget){
            // Use each series' axis label format as its tooltip format if it is available and nothing else is defined.
            _.each(kendoConfig.series, function(serie){
                //Object clone/merge issue workaround
                //Ensure no two series tooltips/labels refer to the same object
                serie.tooltip = _.cloneDeep(serie.tooltip);
                serie.labels = _.cloneDeep(serie.labels);

                var seriesDefaults = kendoConfig.seriesDefaults[serie.type || kendoConfig.seriesDefaults.type] || kendoConfig.seriesDefaults;
                var seriesAxis = serie.axis;

                if (seriesDefaults && seriesAxis && kendoConfig.valueAxes) {

                    var axisConfig = _.find(kendoConfig.valueAxes, function (axis) {
                        return axis.name === seriesAxis 
                    });
                    var axisLabelFormat = axisConfig && axisConfig.labels && axisConfig.labels.format;
                    var seriesTypeHasTooltip = seriesDefaults.tooltip && seriesDefaults.tooltip.visible;
                    var allSeriesHaveTooltips = kendoConfig.seriesDefaults.tooltip && kendoConfig.seriesDefaults.tooltip.visible;
                    var seriesTypeHasNoTooltipFormat = !seriesDefaults.tooltip.format && !kendoConfig.seriesDefaults.tooltip.format;

                    MDB.Charts.setLabelFormat(serie, [axisConfig, seriesDefaults, kendoConfig.seriesDefaults], getCurrentFormatableValues, undefined, undefined, applyExtraLabelFormatting);
                    MDB.Charts.setLabelFormat(serie, [seriesDefaults, kendoConfig.seriesDefaults], getCurrentFormatableValues, serie.field, 'tooltip', applyExtraTooltipFormatting);
                    
                    //ConditionalDisplay on axisLabels breaks the Y-Axis labels
                    if(!axisConfig.labels) {
                        axisConfig.labels = {};
                    }
                    if(!axisConfig.labels.conditionalDisplay) {
                        axisConfig.labels.conditionalDisplay = { _enableConditionalDisplay: false };
                    }

                    MDB.Charts.setLabelFormat(axisConfig, [seriesDefaults, kendoConfig.axisDefaults], getCurrentFormatableValues, serie.field);

                    if (axisLabelFormat && (seriesTypeHasTooltip || allSeriesHaveTooltips) && seriesTypeHasNoTooltipFormat) {
                        if (!serie.tooltip || !serie.tooltip.template){
                            serie.tooltip = {
                                format: axisLabelFormat
                            };
                        }
                    }
                }
            });
        } else{
            _.each(kendoConfig.series, function (serie) {
                MDB.Charts.setLabelFormat(serie, kendoConfig.seriesDefaults, getCurrentFormatableValues, undefined, undefined, applyExtraLabelFormatting);
                MDB.Charts.setLabelFormat(serie, kendoConfig.seriesDefaults, getCurrentFormatableValues, undefined, 'tooltip', applyExtraTooltipFormatting);
            });
        }

        //Delete all but the last label set + position, only this will cause kendo to render the label above the stack
        _.forEach(_.filter(kendoConfig.series, { '_isTotalSeries': true }), function (series) {
            if (!series.labels) {
                series.labels = _.cloneDeep(kendoConfig.seriesDefaults.labels) || { visible: true };
            }

            if (!series.labels.visible){
                series.labels.visible = true;
            }

            series.labels.position = 'insideBase';

            if (series.labels.conditionalDisplay){
                series.labels.conditionalDisplay._enableConditionalDisplay = false;
                series.labels.conditionalDisplay.displayThresholdValue = -1;
            }
        });

        var setSharedMaxLabelValue = function (visibleSeries, valueAxis) {
            if (!sharedValueAxisMax || !valueAxis){
                return;
            }

            var maxLabelValue = calculateSharedMaxLabelValue(data, visibleSeries);

            valueAxis.forEach(function (axis) {
                axis.max = maxLabelValue;
            });
        };

        setSharedMaxLabelValue(kendoConfig.series, kendoConfig.valueAxes);

        MDB.Charts.initializeLegendClickHandler(kendoConfig, function (visibleSeries) {
            setSharedMaxLabelValue(visibleSeries, container.data('kendoChart').options.valueAxis);

            var formatableSeries = visibleSeries;

            if (visibleSeries.length === _.filter(visibleSeries, {'_isTotalSeries': true}).length){
                //Opt for all series when only total is shown due to total being purely calculated based on shown data
                formatableSeries = kendoConfig.series;
            }

            formatableValues = getFormatableValues(formatableSeries, globalDataKey, function (globalDataString) {
                getGlobalDataString = globalDataString;
            });
        });

        chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget)).append(container);
        
        //Using a continuous palette breaks our legend visually
        //the Kendo version we're using does not allow for full control over the legend
        //thus we disable our legend to avoid confusing the user
        //DPN-2216
        if(continuousPalette){
            kendoConfig.legend = { visible: false };
        }
        
        container.kendoChart(kendoConfig);
        
        function getColorGenerator(){
            if(!continuousPalette){
                return undefined;
            }
            
            var colorGeneratorImpl = MDB.Charts.createContinuousPaletteBasedColorGenerator(
                metadata.KendoConfig.seriesColors ||
                kendo.dataviz.ui.themes.default.chart.seriesColors
            );
            
            //Kendo re-renders the full chart upon filtering a specific series
            //to prevent our colors from changing each item; keep a cache
            //with a color per item
            var cache = {};
            
            return function(data){
                //Generate a single color per stack
                var series = data.series;
                
                var cacheKey = data.category;
                if(stackField) cacheKey += '_' + series.name;
                if(stackGroup) cacheKey += '_' + series.stack.group;
                
                return cache[cacheKey] || (cache[cacheKey] = colorGeneratorImpl());
            };
        }

        function getFormatableValues(visibleSeries, globalDataKey, setGlobalDataString) {
            var availableCategories = _.map(visibleSeries, '_category');
            var availableGroups = _.map(visibleSeries, 'stack.group');

            var visibleData = data;
            if (visibleSeries !== undefined) {
                visibleData = _.filter(data, function (dataItem) {
                    return availableCategories.indexOf(dataItem[stackField]) !== -1 && (!hasGroups || availableGroups.indexOf(dataItem[stackGroup]) !== -1);
                });
            }

            var dataValueKeys = stackConfig !== undefined ? [keyMappingFields[valueIndex]] : _.slice(keyMappingFields, 1);

            var visibleDataValues = _.map(visibleData, function (dataItem) {
                return _.pick(dataItem, dataValueKeys); 
            });
            var formatableValues = MDB.Charts.getAggregatedFormatableValues(visibleDataValues, keyMappingFields);

            //Apply custom label formatting
            //Explicitely check for known types
            if (!stackConfig || !(stackConfig.type === '100%' || stackConfig.type === 'false')){
                return formatableValues;
            }

            var dataPerCategory = _.groupBy(visibleData, category);
            var formatableValuesPerCategory;

            if (!hasGroups) {
                formatableValuesPerCategory = _.map(_.keys(dataPerCategory), function (key) {
                    var dpc = dataPerCategory[key];
                    var formatableValues = MDB.Charts.getAggregatedFormatableValues(dpc, _.keys(dpc[0]));

                    return {
                        category: key,
                        values: _.find(formatableValues, { key: keyMappingFields[valueIndex] }),
                        valueFor: formatableValues.valueFor
                    };
                });
            } else {
                //Also groupBy... group 
                formatableValuesPerCategory = _.map(_.keys(dataPerCategory), function (key) {
                    var dataPerCategoryGroup = _.groupBy(dataPerCategory[key], stackGroup);
                    var availableGroups = _.keys(dataPerCategoryGroup);

                    dataPerCategoryGroup = _.map(_.intersection(groups, availableGroups), function (group) {
                        var dpcg = dataPerCategoryGroup[group];
                        var formatableValues = MDB.Charts.getAggregatedFormatableValues(dpcg, _.keys(dpcg[0]));

                        return {
                            group: group,
                            values: _.find(formatableValues, { key: keyMappingFields[valueIndex] }),
                            valueFor: formatableValues.valueFor
                        };
                    });

                    dataPerCategoryGroup.category = key;
                    return dataPerCategoryGroup;
                });
            }

            var getItemFormatableValue = function (formatType, args) {
                var category = args.category;

                //We use stringified categories
                if (!_.isString(category)) {
                    if (category instanceof Date) {
                        category = kendo.toString(category, 's');
                    } else if((category !== undefined) && category.toString) {
                        category = category.toString();
                    }
                }

                var values = _.find(formatableValuesPerCategory, { category: category });
                if (hasGroups) {
                    values = _.find(values, { group: args.series.stack.group });
                }

                var valuesMissing = !values
                    , dataMissing = !args.dataItem || args.dataItem[keyMappingFields[valueIndex]] === undefined || args.dataItem[keyMappingFields[valueIndex]] === null;

                if (valuesMissing || dataMissing) {
                    if (totalStack) {
                        if (!args.series._isTotalSeries || (valuesMissing && dataMissing)) {
                            //Since this label renderer is forced, prevent a label showing 'undefined' from popping up
                            return '';
                        }
                    } else {
                        return undefined;
                    }
                }
                
                if (totalStack && args.series._isTotalSeries) {
                    //Full stack labels should always be based on percentageTotal
                    args.value = values.valueFor(keyMappingFields[valueIndex], 'percentagTotal');
                    
                    //Return the stack's total value
                    if (!formatType) {
                        return args.value;
                    }

                    var targetValues = hasGroups ?
                        _.filter(_.flatMap(formatableValuesPerCategory), { group: args.series.stack.group }) :
                        formatableValuesPerCategory;

                    //Simply take the highest stack total;
                    if (formatType === 'percentageMax') {
                        var allTotalValues = _.map(targetValues, function (values) {
                            return values.valueFor(keyMappingFields[valueIndex], 'percentagTotal');
                        });

                        return _.max(allTotalValues);
                    } else if (formatType === 'percentageTotal') {
                        //Take the total from all values
                        return formatableValues.valueFor('__TOTALS__', 'percentageTotal');
                    } else {
                        return kendo.format(formatType, args.value);
                    }
                }

                var displayValue = values.valueFor(keyMappingFields[valueIndex], formatType);

                if (totalStack && !displayValue) {
                    displayValue = args.dataItem[keyMappingFields[valueIndex]];
                }

                return displayValue;
            };

            var globalDataKey = MDB.Charts.registerGlobalData(getItemFormatableValue, globalDataKey);

            //Only the valueFor function is actually used, override it with our own and return our global data value
            return {
                valueFor: function (field, formatType) {
                    var getGlobalDataString = undefined;

                    //Verify whether we can actually return a valid value
                    if (formatableValues.valueFor(field,  formatType)){
                        getGlobalDataString = sprintf('MDB.Charts.getGlobalData(\'%s\')(\'%s\', arguments[0])', globalDataKey, formatType);
                    }

                    setGlobalDataString(getGlobalDataString);
                    return getGlobalDataString;
                },
                valueForItem: function(field, formatType, args) {
                    if (formatableValues.valueFor(field, formatType) && args) {
                        return getItemFormatableValue(formatType, args);
                    }

                    return undefined;
                }
            };
        }
    }, 0);

    function calculateSharedMaxLabelValue(data, visibleSeries) {
        var seriesFields = _.map(visibleSeries, 'field');
        var majorGridline = 10;

        //Take all visible values -> convert to floating point numbers -> take max
        var maxValue = _.max(_.flatMap(data, function(i){
            return _.map(_.values(_.pick(i, seriesFields)), parseFloat) 
        }));

        //Starting from 20, the major gridlines show up at an interval of 10
        if ((maxValue * 1.2) > 20){
            //https://stackoverflow.com/a/18953446/3697715
            maxValue = Math.ceil(maxValue / majorGridline) * majorGridline;

            return Math.max(maxValue * 1.2, maxValue + majorGridline);
        }

        return maxValue * 1.2;
    }

    function embedCustomValueColors(kendoConfig){
        if (kendoConfig.customValueColors) {
            kendoConfig.seriesDefaults.color = getColorFunction(kendoConfig.customValueColors.ranges);
        }

        if (kendoConfig.customValueColors && kendoConfig.customValueColors.legendPosition) {
            var containerCss = {
                'position': 'absolute',
                'cursor': 'default', //As long as the items aren't clickable, don't alter the cursor
                'z-index': 1
            };

            var legendPosition = kendoConfig.customValueColors.legendPosition;

            var ranges = kendoConfig.customValueColors.ranges;
            var colorLegend = _.map(ranges, function (range) {
                var from = range.from;
                var to = range.to;

                var toDefined = !_.isUndefined(to);
                var fromDefined = !_.isUndefined(from);
                var bothDefined = toDefined && fromDefined;

                var template = sprintf('%s%s %s',
                    bothDefined ? from + ' ' : '',
                    bothDefined ? '-' : (toDefined ? '<=' : '>='),
                    bothDefined ? to : (toDefined ? to : from)
                );

                var subContainerCss = {};

                if (['top', 'bottom'].indexOf(legendPosition) !== -1) {
                    subContainerCss['display'] = 'inline-block';
                }

                return $('<div />').css(subContainerCss)
                    .append($('<div />').css({
                        'display': 'inline-block',
                        'margin-bottom': '2px',
                        'margin-left': '5px',
                        'margin-right': '5px',
                        'height': '7px',
                        'width': '7px',

                        'background-color': range.color
                    }))
                    .append($('<span />').css({ 'color': 'black' }).text(template))
                    .prop('outerHTML');
            });

            if (['top', 'bottom'].indexOf(legendPosition) !== -1) {
                containerCss['display'] = 'inline-block';
                containerCss['width'] = '100%';
                containerCss['left'] = '40%';

                if (legendPosition === 'bottom') {
                    containerCss['top'] = '95%';
                }
            }

            if (['left', 'right'].indexOf(legendPosition) !== -1) {
                //Assume 20px per custom label, ~9px per kendo label
                var top = (chart.height() / 2) - (ranges.length * 20);// - (series.length * 9);

                containerCss['top'] = top + 'px';

                containerCss[legendPosition] = '10px';
                container.width('80%');

                if (legendPosition === 'left') {
                    container.css('left', '15%');
                }
            }

            chart.prepend($('<div />').css(containerCss).html(colorLegend));
        }
    }

    function getColorFunction(ranges) {
        var funcBody = '';

        ranges.forEach(function(range) {
            funcBody += 'if (e.value ';
            if (range.from) {
                funcBody += '>= ' + range.from;
            }
            if (range.from && range.to) {
                funcBody += ' && e.value';
            }
            if (range.to) {
                funcBody += '<= ' + range.to;
            }
            funcBody += ') { return "' + range.color + '"; }\n';
        });

        funcBody += 'return undefined;';

        return Function('e', funcBody);
    }
};